<template>
  <div class="translation">
    <div class="container-fluid py-4">
      <div class="mt-5">
        <transition name="fade" mode="out-in">
          <default-card
            :languages="languages"
            :userInput="userInput"
            :resultOutput="resultOutput"
            :parse-markdown="parseMarkdown"
            @file-uploaded="handleFileUpload"
            @input-message="handleTranslate"
            @handle-office-file-download="handleOfficeFileDownload"
          />
        </transition>
      </div>
    </div>
  </div>
  <div v-if="false" class="container">
    <div class="top-row">
      <div class="model-selector">
        <select
          id="modelSelector"
          v-model="selectedModel"
          @change="onModelChange"
        >
          <option value="gpt-4o">ChatGPT-4o</option>
          <option value="claude-3-5-sonnet">Claude 3.5 Sonnet</option>
        </select>
      </div>
    </div>
    <div class="language-row">
      <div class="language-label">言語を自重検出</div>
      <div class="language-selector">
        <select v-model="selectedLanguage">
          <option
            v-for="language in languages"
            :key="language"
            :value="language"
          >
            {{ language }}
          </option>
        </select>
      </div>
    </div>
    <div class="chatbot-input">
      <div class="message-area">
        <textarea
          v-model="userInput"
          placeholder="入力してください"
          @keydown.enter.prevent="handleEnterKey"
          @input="autoResize"
          spellcheck="false"
        ></textarea>
      </div>
      <div class="result-area">
        <div
          class="result"
          ref="chatbotResult"
          v-html="parseMarkdown(resultOutput)"
        ></div>
        <button
          class="copy-button"
          @click="copyContent"
          :disabled="resultOutput === ''"
        >
          <CIcon :icon="cilCopy" />
        </button>
      </div>
    </div>
    <div class="system-prompt-container">
      <div class="system-prompt-label" @click="togglePromptCollapse">
        <span class="toggle-icon" :class="{ expanded: !isPromptCollapsed }"
          >▶</span
        >
        {{ getPromptLabel }}
      </div>
      <div v-if="!isPromptCollapsed" class="prompt-input">
        <input
          id="system-prompt"
          type="text"
          v-model="promptValue"
          @keydown.enter.prevent="translateText"
          spellcheck="false"
        />
      </div>
    </div>
    <div class="generate-button-container">
      <button
        class="generate-button"
        @click="translateText"
        :disabled="isProcessing || !userInput"
        :class="{ generating: isProcessing }"
      >
        実行
      </button>
    </div>
  </div>
  <!-- Overlay for processing message -->
  <ProcessingOverlay :show="isProcessing" />
  <ErrorPopup
    :show="showErrorPopup"
    :message="errorMessage"
    @close="closeErrorPopup"
  />
</template>

<script>
import { cilCopy } from '@coreui/icons'
import DOMPurify from 'isomorphic-dompurify'
import { marked } from 'marked'
import ProcessingOverlay from '@/components/ProcessingOverlay.vue'
import ErrorPopup from '@/components/ErrorPopup.vue'
import DefaultCard from './components/DefaultCard.vue'
//import StorageService from '@/services/StorageService'
import { NAV_MASTER } from '@/constants/navMaster'
import HTTPService from '@/services/HTTPService'
import { useAuthStore } from '@/store/auth'

export default {
  components: {
    DefaultCard,
    ProcessingOverlay,
    ErrorPopup,
  },
  data() {
    return {
      cilCopy,
      selectedModel: 'gpt-5.6-terra',
      selectedModelLabel: 'gpt-5.6-terra（スピード重視）',
      //selectedModel: 'gpt-5-nano',
      //selectedModelLabel: 'ChatGPT-5 nano',
      promptLabelText: '追加コンテキスト - Optional',
      isPromptCollapsed: true,
      autoCorrect: false,
      isProcessing: false,
      showErrorPopup: false,
      errorMessage: '',
      promptValue: '',
      userInput: '',
      bot_id: '',
      botName: '',
      conversationId: '',
      attachedFiles: [],
      selectedLanguage: '英語',
      resultOutput: '',
      maxPerFileMB: 50,
      languages: [
        '英語',
        '日本語',
        '中国語（簡体字）',
        '中国語（繁体字）',
        'フランス語',
        'スペイン語',
        'ドイツ語',
        'ポルトガル語',
        /*
        'アフリカーンス語',
        'アルバニア語',
        'アムハラ語',
        'アラビア語',
        'アルメニア語',
        'アゼルバイジャン語',
        'バスク語',
        'ベラルーシ語',
        'ベンガル語',
        'ボスニア語',
        'ブルガリア語',
        'カタロニア語',
        'セブアノ語',
        'チェワ語',
        'コルシカ語',
        'クロアチア語',
        'チェコ語',
        'デンマーク語',
        'オランダ語',
        'エスペラント語',
        'エストニア語',
        'フィリピン語',
        'フィンランド語',
        'フリジア語',
        'ガリシア語',
        'グルジア語（ジョージア語）',
        'ギリシャ語',
        'グジャラート語',
        'ハイチ語（クレオール）',
        'ハウサ語',
        'ハワイ語',
        'ヘブライ語',
        'ヒンディー語',
        'モン語',
        'ハンガリー語',
        'アイスランド語',
        'イボ語',
        'インドネシア語',
        'アイルランド語',
        'イタリア語',
        'ジャワ語',
        'カンナダ語',
        'カザフ語',
        'クメール語',
        '韓国語',
        'クルド語（クルマンジー）',
        'キルギス語',
        'ラオ語',
        'ラテン語',
        'ラトビア語',
        'リトアニア語',
        'ルクセンブルク語',
        'マケドニア語',
        'マダガスカル語',
        'マレー語',
        'マラヤーラム語',
        'マルタ語',
        'マオリ語',
        'マラーティー語',
        'モンゴル語',
        'ミャンマー語（ビルマ語）',
        'ネパール語',
        'ノルウェー語',
        'オリヤ語',
        'パシュト語',
        'ペルシャ語',
        'ポーランド語',
        'パンジャーブ語',
        'ルーマニア語',
        'ロシア語',
        'サモア語',
        'スコットランド・ゲール語',
        'セルビア語',
        'セソト語',
        'ショナ語',
        'シンド語',
        'シンハラ語',
        'スロバキア語',
        'スロベニア語',
        'ソマリ語',
        'スンダ語',
        'スワヒリ語',
        'スウェーデン語',
        'タジク語',
        'タミル語',
        'タタール語',
        'テルグ語',
        'タイ語',
        'トルコ語',
        'トルクメン語',
        'ウクライナ語',
        'ウルドゥー語',
        'ウイグル語',
        'ウズベク語',
        'ベトナム語',
        'ウェールズ語',
        'コーサ語',
        'イディッシュ語',
        'ヨルバ語',
        'ズールー語',
        */
      ],
    }
  },
  computed: {
    getPromptLabel() {
      return this.promptLabelText
    },
  },
  methods: {
    onModelChange() {
      console.log('Selected model:', this.selectedModel)
    },
    togglePromptCollapse() {
      this.isPromptCollapsed = !this.isPromptCollapsed
    },
    async handleFileUpload(file) {
      const allowedTypes = [
        'application/pdf',
        'text/csv',
        'text/plain',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      ]

      const fileSizeMB = file.size / (1024 * 1024) // MB換算
      if (fileSizeMB > this.maxPerFileMB) {
        this.errorMessage = `・「${file.name}」はサイズが大きすぎます。\r\n・アップロードは１ファイル最大 ${this.maxPerFileMB}MBまでとなります。\r\n・ファイルを圧縮するか、分割してお試しください。`
        this.showErrorPopup = true
        return
      }

      if (!allowedTypes.includes(file.type)) {
        this.errorMessage =
          'ファイルの読み込むことができませんでした。\r\n' +
          '以下のファイル形式に対応しています。\r\n' +
          '「pdf, csv, txt, doc, docx, xls, xlsx, ppt, pptx」'
        this.showErrorPopup = true
        return
      }

      this.attachedFiles = []
      this.attachedFiles.push(file)
      this.userInput = ''
      this.isProcessing = true
      await this.translateFile() // translateFile() の完了を待つ
      await this.translateText() // その後 translateText() を実行

      window.gtag('event', 'API', {
        event_name: '翻訳しチャオ',
        action: 'ファイルアップロード',
        model: this.selectedModelLabel,
        id: this.$store.state.userId,
      })
    },
    handleTranslate(obj) {
      this.userInput = obj.userInput
      this.promptValue = obj.promptValue
      this.selectedLanguage = obj.selectedLanguage

      if (this.userInput) {
        this.translateText()
        window.gtag('event', 'API', {
          event_name: '翻訳しチャオ',
          action: '文章入力',
          model: this.selectedModelLabel,
          id: this.$store.state.userId,
        })
      }
    },
    async handleOfficeFileDownload(type) {
      if (this.resultOutput === '') return

      this.isProcessing = true
      const response = await HTTPService.office_file_download(
        '',
        type,
        this.resultOutput,
      )

      if (response && response.status === 401) {
        localStorage.setItem('expired', 'true')
        window.location.href = '/login'
        return
      }

      const data = response.data
      await HTTPService.fetchAndDownload(data.s3_url, data.filename)
      await HTTPService.delete_office_file(data.filepath)

      this.isProcessing = false
    },
    async translateText() {
      // Implementation for text correction
      //if (!this.userInput || this.isStreaming || this.isProcessing) return
      if (!this.userInput || this.isStreaming) return
      /*
      if (this.promptValue) {
        this.promptValue =
          this.promptValue +
          '「' +
          this.selectedLanguage +
          '」で翻訳結果のみ出力してください。日本語は出力に含めないでください。'
      }
      */
      const data = {
        user_input: this.userInput,
        prompt: this.promptValue,
        model: this.selectedModel,
        language: this.selectedLanguage,
      }

      this.resultOutput = ''
      this.isProcessing = true
      this.isStreaming = true

      try {
        //let token = StorageService.getToken()
        const auth = useAuthStore()
        const response = await fetch(
          `${process.env.VUE_APP_API_URL}/translate-text`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'text/event-stream',
              Authorization: `Bearer ${auth.token}`,
            },
            body: JSON.stringify(data),
          },
        )

        if (response && response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
          return
        }

        this.isProcessing = false

        if (!response.ok) {
          const errorBody = await response.json()
          this.errorMessage =
            errorBody.error ||
            `HTTP error! status: ${response.status} ${response.statusText}`
          this.showErrorPopup = true
          throw new Error(this.errorMessage)
        }

        const reader = response.body.getReader()
        const decoder = new TextDecoder()

        // eslint-disable-next-line no-constant-condition
        while (true) {
          const { done, value } = await reader.read()
          if (done) break

          const chunk = decoder.decode(value, { stream: true })
          const lines = chunk.split('\n').filter(Boolean)

          for (const line of lines) {
            if (line.startsWith('data:')) {
              const data = line.slice(5)
              if (data.includes('[DONE]')) {
                // Streaming is complete
                console.log('Streaming complete')
                return
              } else {
                this.resultOutput += `${data.slice(1)}`
                //this.$refs.chatbotResult.scrollTop =
                //  this.$refs.chatbotResult.scrollHeight
              }
            }
          }
        }
      } catch (error) {
        console.error('Error correct text:', error.response.data.error)
        if (error.response && error.response.data.error) {
          this.errorMessage = error.response.data.error
          this.showErrorPopup = true
        }
      } finally {
        this.isProcessing = false
        this.isStreaming = false
      }
    },

    async translateFile() {
      if (!this.userInput && this.attachedFiles.length === 0) return

      const formData = new FormData()
      formData.append('file', this.attachedFiles[0])

      //const data = {
      //  bot_id: this.bot_id,
      //  user_input: this.userInput,
      //  prompt: '文字起こしをしてください。前後に挨拶や説明は不要です。',
      //  model: this.selectedModel,
      //}

      this.userInput = ''
      this.isProcessing = true

      try {
        this.isSummarizing = true
        const response = await HTTPService.translate_file(formData)

        this.userInput = response.data.text ?? ''
        this.isProcessing = false
      } catch (error) {
        console.error(`exception: ${error}`)
        if (!this.showErrorPopup) {
          this.errorMessage = error.message || 'An unknown error occurred'
          this.showErrorPopup = true
        }
      } finally {
        this.isSummarizing = false
      }
    },

    async createChatbot() {
      const formData = new FormData()
      if (this.attachedFiles) {
        for (let i = 0; i < this.attachedFiles.length; i++) {
          formData.append('files[]', this.attachedFiles[i])
        }
      }
      if (this.botName) {
        formData.append('data', JSON.stringify({ bot_name: this.botName }))
      }

      // 翻訳しチャオ
      formData.append('nav_id', NAV_MASTER.TRANSLATION)

      await HTTPService.createChatbot(formData)
        .then((response) => {
          this.showConfirmation = true
          this.bot_id = response.data.bot_id
        })
        .catch((error) => {
          console.error(error)
          if (error.response && error.response.status === 401) {
            return
          }
          if (error.response && error.response.data.error) {
            this.errorMessage = error.response.data.error
            this.showErrorPopup = true
            if (
              error.response &&
              (error.response.status === 423 || error.response.status === 424)
            ) {
              this.planerror = true
            }
          } else {
            this.errorMessage =
              'ファイルの読み込むことができませんでした。\r\n' +
              '以下のファイル形式に対応しています。\r\n' +
              '「pdf, csv, txt, doc, docx, xls, xlsx, ppt, pptx」'
            this.showErrorPopup = true
          }
        })
    },

    copyContent() {
      const range = document.createRange()
      range.selectNode(this.$refs.chatbotResult)
      const selection = window.getSelection()
      selection.removeAllRanges()
      selection.addRange(range)
      document.execCommand('copy')
      window.getSelection().removeAllRanges()
    },
    parseMarkdown(text) {
      if (typeof text !== 'string') {
        return '' // Return the text as is if it's not a string
      }

      text = text.replaceAll('\\n', '\n')
      text = text.replaceAll('```markdown', '```')
      try {
        const renderer = new marked.Renderer()
        renderer.link = function (href, title, text) {
          // Renderer() seems to return different parameters depending on the version of marked installed...
          const link = {
            href: href.href ?? href,
            text: href.text ?? text,
          }
          return (
            '<a target="_blank" href="' + link.href + '">' + link.text + '</a>'
          )
        }

        //text = text.replaceAll('```', '')
        let parsed = marked(text, { renderer: renderer })

        // format Bing's source links more nicely
        // 1. replace "[^1^]" with "[1]" (during progress streams)
        parsed = parsed.replace(/\[\^(\d+)\^]/g, '<strong>[$1]</strong>')
        // 2. replace "^1^" with "[1]" (after the progress stream is done)
        parsed = parsed.replace(/\^(\d+)\^/g, '<strong>[$1]</strong>')

        // Allow the iframe to show the images created by Bing Image Creator.
        return DOMPurify.sanitize(parsed, {
          ADD_TAGS: ['iframe'],
          ADD_ATTR: [
            'allow',
            'allowfullscreen',
            'frameborder',
            'scrolling',
            'srcdoc',
            'target',
          ],
        })
      } catch (err) {
        console.error('ERROR', err)
        return null
      }
    },
    handleEnterKey(event) {
      if (event.shiftKey) {
        // Allow Shift + Enter to create a new line
        const textarea = event.target
        const cursorPosition = textarea.selectionStart
        this.userInput =
          this.userInput.slice(0, cursorPosition) +
          '\n' +
          this.userInput.slice(cursorPosition)
        this.$nextTick(() => {
          textarea.selectionStart = cursorPosition + 1
          textarea.selectionEnd = cursorPosition + 1
        })
      } else {
        // Handle normal Enter keypress
        this.translateText()
      }
    },
    closeErrorPopup() {
      this.showErrorPopup = false
      this.errorMessage = ''
    },
  },
}
</script>

<style scoped>
.container {
  height: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  border: 3px solid #001d61;
  border-radius: 10px;
  background-color: rgb(240, 245, 245);
}

.top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.model-selector {
  width: 50%;
}

.model-selector select {
  width: 100%;
  padding: 5px;
  border-radius: 5px;
  border: 1px solid #000;
  font-size: 14px;
  height: 30px;
}

.auto-correct {
  display: flex;
  align-items: center;
}

.auto-correct span {
  margin-left: 5px;
  font-size: 18px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 49px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 20px;
}

.slider:before {
  position: absolute;
  content: '';
  height: 20px;
  width: 20px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #ff8c00;
}

input:checked + .slider:before {
  transform: translateX(20px);
}

.language-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.language-label {
  font-size: 16px;
  font-weight: bold;
  width: 60%;
  margin-right: 10px;
}

.language-selector {
  width: 40%;
}

.language-selector select {
  width: 100%;
  border-radius: 5px;
  border: 1px solid #000;
  font-size: 14px;
  height: 30px;
}

.chatbot-input {
  display: flex;
  flex: 1;
  margin-bottom: 15px;
  min-height: 0; /* This is crucial for nested flex containers */
}

.message-area,
.result-area {
  display: flex;
  flex-direction: column;
  border: 1px solid rgb(218, 223, 227);
  border-radius: 5px;
  min-height: 0;
  font-family: inherit; /* Ensure consistent font family */
  color: inherit; /* Ensure consistent text color */
  font-size: 14px; /* Ensure consistent font size */
}

.message-area {
  width: 60%;
  margin-right: 10px;
  position: relative;
}

.result-area {
  width: 40%;
  position: relative;
  overflow: hidden;
}

.message-area textarea,
.result-area .result {
  width: 100%;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  background-color: #fff;
  font-family: inherit;
  color: inherit;
  font-size: 14px;
}

.message-area textarea {
  height: 100%;
  resize: none;
}

.result-area .result {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
}

.copy-button {
  position: absolute;
  bottom: 10px;
  right: 10px;
  padding: 5px 10px;
  background-color: transparent;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  z-index: 1;
}

.copy-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.copy-button:hover {
  background-color: #e0e0e0;
}

.system-prompt-container {
  margin-bottom: 15px;
}

.system-prompt-label {
  font-weight: bold;
  margin: 0 0 5px 5px;
  font-size: 14px;
  cursor: pointer;
}

.toggle-icon {
  display: inline-block;
  margin-right: 5px;
  transition: transform 0.3s ease;
}

.toggle-icon.expanded {
  transform: rotate(90deg);
}

.prompt-input {
  display: flex;
  align-items: center;
}

.prompt-input input {
  flex: 1;
  padding: 10px 15px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
}

.generate-button-container {
  display: flex;
  justify-content: flex-end;
}

.generate-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.generate-button {
  padding: 10px 20px;
  background-color: #001d61;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.generate-button:hover .upload-button:hover {
  background-color: #002b8f;
}

.generate-button.generating {
  background-color: #808080;
  cursor: not-allowed;
}

.processing-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.processing-message {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}

.loading-icon-wrapper {
  margin-bottom: 10px;
}

.loading-icon {
  width: 50px;
  height: 50px;
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.popup-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  width: 400px;
}

.popup-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
</style>
